/* eslint-disable react-hooks/exhaustive-deps */
import { selectCurrentSessionId, selectIsLoading, SelectMessages, selectTemporarySessionId } from '../slice/selectors';
import { useCallback, useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { useChatSlice } from '../slice';
import { usePortalSlice } from '../../../layouts/MainLayout/slice';

export default function useChatSessionHandler() {
  const messages = useSelector(SelectMessages);
  const currentSessionId = useSelector(selectCurrentSessionId);
  const temporarySessionId = useSelector(selectTemporarySessionId);
  const isLoading = useSelector(selectIsLoading);
  const dispatch = useDispatch();
  const { actions: chatActions } = useChatSlice();
  const { actions: portalActions } = usePortalSlice();

  const getChatSession = useCallback(() => {
    if (currentSessionId && !temporarySessionId) {
      dispatch(chatActions.getMessages(currentSessionId as string));
    } else if (temporarySessionId && currentSessionId) {
      dispatch(chatActions.cleanTemporarySession());
      dispatch(portalActions.getCurrentChatSession(currentSessionId));
    }
  }, [currentSessionId, temporarySessionId]);

  useEffect(() => {
    getChatSession();
  }, [currentSessionId]);

  // useEffect(() => {
  //   dispatch(chatActions.onNewChat());
  // }, [sessionUserId]);

  return { messages, currentSessionId, isLoading };
}
